/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { useHistory } from 'react-router-dom';

import { BrandColors, LoneIconButton } from '@blend/enterprise-components';

export namespace Sidebar {
  export interface Props {}
}

export const styles = StyleSheet.create({
  sidebarContainer: {
    backgroundColor: BrandColors.NIGHT,
    display: 'flex',
    flexBasis: 70,
    flexDirection: 'column',
    flexGrow: 0,
    flexShrink: 0,
    height: '100vh',
    justifyContent: 'space-between',
    padding: 20,
  },
});
export const Sidebar: React.FC<Sidebar.Props> = ({}) => {
  const history = useHistory();
  return (
    <div className={css(styles.sidebarContainer)}>
      <LoneIconButton
        data-it="back-button"
        btnSize="sm"
        icon="arrow_back"
        iconSize={24}
        onClick={() => {
          history.push('/notary/rooms');
        }}
        theme="light"
      />
    </div>
  );
};
